const empty = { value: null, label: "Non spécifiée", iconClass: '', color: '' }

export const priorities = [
  { value: 4, label: "Très haute", iconClass: 'fa-arrow-up',   color: 'rgb(199, 4, 4)' },
  { value: 3, label: "Haute",      iconClass: 'fa-arrow-up',   color: 'rgb(199, 157, 4)' },
  { value: 2, label: "Moyenne",    iconClass: 'fa-arrow-up',   color: 'rgb(0, 171, 3)' },
  { value: 1, label: "Basse",      iconClass: 'fa-arrow-down', color: 'rgb(0, 171, 3)' }
]

const prioritiesByValue = {
  4: priorities[0],
  3: priorities[1],
  2: priorities[2],
  1: priorities[3]
}

export const getPriorityFromValue = function(value) {
  if (!value) { return empty }
  return prioritiesByValue[value]
}

export const prioritiesMixin = {
  data: function() {
    return {
      priorities
    }
  },
  methods: {
    getPriorityFromValue
  }
}